import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar2 from '../components/Navbar2';
import StylesLeftPredefined from '../components/StylesLeftPredefined';
import StylesLeftCustom from '../components/StylesLeftCustom';
import StylesRight from '../components/StylesRight';
import palettes from '../data/palettes.json';
import { updateProjectStyle } from '../services/database';


const StyleChoices = () => {
  
  const location = useLocation();
  const navigate = useNavigate();
  const { projectId } = location.state || {};

  // Initialize with default values
  const [userChoices, setUserChoices] = useState({
    device: 'Desktop',
    theme: 'light',
    palette: 'Classic Light',
    font: 'Native UI',
    isCustomPalette: false,
    customPaletteId: null
  });

  // State to track which style type is active (predefined or custom)
  const [styleType, setStyleType] = useState('predefined');

  // Get existing style choices if they exist
  useEffect(() => {
    const fetchProjectDetails = async () => {
      if (projectId && location.state?.styleChoices) {
        const existingChoices = location.state.styleChoices;
        
        // If user had a custom palette selected, switch to custom tab
        if (existingChoices.isCustomPalette && existingChoices.customPaletteId) {
          setStyleType('custom');
        }
        
        setUserChoices(prevChoices => ({
          ...prevChoices,
          ...existingChoices
        }));
      }
    };

    fetchProjectDetails();
  }, [projectId, location.state]);

  // Handle switching between predefined and custom styles
  const handleStyleTypeChange = (type) => {
    setStyleType(type);
    
    // Reset userChoices to defaults based on selected type
    if (type === 'predefined') {
      setUserChoices(prev => ({
        device: prev.device, // Keep device selection
        theme: 'light',
        palette: palettes.light[0].name,
        font: prev.font, // Keep font selection
        isCustomPalette: false,
        customPaletteId: null
      }));
    } else {
      // For custom, we'll let the component set the selected palette 
      // from the available custom palettes when it loads
      setUserChoices(prev => ({
        device: prev.device, // Keep device selection
        theme: 'light',
        palette: '',
        font: prev.font, // Keep font selection
        isCustomPalette: true,
        customPaletteId: null
      }));
    }
  };

  const handleSaveAndContinue = async () => {
    if (!projectId) {
      console.error('Project ID is missing');
      return;
    }
    
    try {
      await updateProjectStyle(projectId, userChoices);
      console.log('Style choices updated successfully');
      // Navigate to ProjectDetails.js and pass projectId
      navigate('/project-details', { state: { projectId } });
    } catch (error) {
      console.error('Error updating style choices:', error);
      // Handle error (e.g., show notification to user)
    }
  };

  return (
    <div className="h-full w-full font-sans antialiased overflow-hidden">
      <Navbar2 
        title="Project Settings" 
        backPath="/projects" 
        styleType={styleType}
        onStyleTypeChange={handleStyleTypeChange}
      />

      <div className="flex h-[calc(100vh-88px)]">
        <div className="md:w-1/3 overflow-y-auto">
          {styleType === 'predefined' ? (
            <StylesLeftPredefined
              userChoices={userChoices}
              setUserChoices={setUserChoices}
              onSaveAndContinue={handleSaveAndContinue}
            />
          ) : (
            <StylesLeftCustom
              userChoices={userChoices}
              setUserChoices={setUserChoices}
              onSaveAndContinue={handleSaveAndContinue}
            />
          )}
        </div>
        <div className="hidden md:flex md:w-2/3 overflow-y-auto">
          <StylesRight userChoices={userChoices} />
        </div>
      </div>
    </div>
  );
};

export default StyleChoices;